import { combineReducers } from "redux";
import visitors from "./visitor";
import trainees from "./trainee";
import letters from "./letter";
import superAdmin from "./superAdmin";
import channelPartner from "./channelPartner";

export const reducers = combineReducers({
  visitors,
  trainees, 
  letters,
  superAdmin,
  channelPartner
});
